import type { SeoService } from './core';

const GLOBAL_DESCRIPTION_COPY: Record<SeoService, string> = {
  חתונה:
    'תקליטן לחתונה עם מעל 15 שנות ניסיון, תכנון מוזיקלי אישי, קריאת קהל חדה, ליווי לחופה ולסלואו ואווירה מדויקת מהקבלת פנים ועד הרחבה.',
  חינה:
    'תקליטן לחינה עם מעל 15 שנות ניסיון, מוזיקה עדתית ומזרחית, כניסות וטקס חינה בתיאום מלא ושילוב טבעי בין מסורת לקצב שמרים את הרחבה.',
  'בר-מצווה':
    'תקליטן לבר מצווה או תקליטן לבת מצווה עם מעל 15 שנות ניסיון, כניסה מרשימה, מוזיקה לנוער ולמשפחה וניהול מוזיקלי מדויק לכל שלב.',
  אירוע:
    'תקליטן מומלץ לאירועים עם מעל 15 שנות ניסיון, שליטה במגוון רחב של סגנונות מוזיקליים, התאמה מדויקת לקהל ובניית אווירה שמתאימה לכל אירוע.',
};

const LOCAL_DESCRIPTION_COPY: Record<SeoService, (locationLabel: string) => string> = {
  חתונה: (locationLabel) =>
    `תקליטן מומלץ לחתונה ב${locationLabel} עם מעל 15 שנות ניסיון, תכנון מוזיקלי אישי, קריאת קהל חדה, מיקסים מדויקים ויצירת אווירה מדויקת לכל רגע בחתונה.`,
  חינה: (locationLabel) =>
    `תקליטן מומלץ לחינה ב${locationLabel} עם מעל 15 שנות ניסיון, מוזיקה לכל העדות ושילוב מושלם של מסורת ומודרניות לחגיגה שמחה, צבעונית ומיוחדת.`,
  'בר-מצווה': (locationLabel) =>
    `תקליטן מומלץ לבר/בת מצווה ב${locationLabel} עם מעל 15 שנות ניסיון, מוזיקה שמחברת נוער ומשפחה, קריאת קהל חדה וניהול מוזיקלי מדויק לאירוע שמח ומרגש.`,
  אירוע: (locationLabel) =>
    `תקליטן מומלץ לאירוע ב${locationLabel} עם מעל 15 שנות ניסיון, תכנון מוזיקלי והתאמה מדויקת לקהל, שליטה במגוון רחב של סגנונות ובניית אווירה לאירוע שמח ומדויק.`,
};

export const HOME_SEO_DESCRIPTION =
  'די ג׳יי מומלץ לאירועים עם מעל 15 שנות ניסיון, אלפי אירועים ועשור די ג׳יי הבית של מועדון הפורום, מוזיקה בהתאמה אישית, קריאת קהל חדה ובניית האווירה לכל רגע באירוע.';

export function buildGlobalSeoDescription(service: SeoService) {
  return GLOBAL_DESCRIPTION_COPY[service];
}

export function buildLocalSeoDescription(service: SeoService, locationLabel: string) {
  const loc = String(locationLabel || '').trim();
  if (!loc) return buildGlobalSeoDescription(service);
  return LOCAL_DESCRIPTION_COPY[service](loc);
}
